import { useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { clsx } from 'clsx';
import { TDescriptionValue } from 'shared/types/typographyComponents';

interface ICustomListProps {
  items: TDescriptionValue[][];
}

export const CustomList: React.FC<ICustomListProps> = ({ items }) => {
  const device = useDeviceType();

  return (
    <ul className={clsx(styles['list'], styles[device])}>
      {items.map((item, key) => (
        <li className={styles['item']} key={key}>
          {item.map(({ value, isBold }, strKey) => {
            if (isBold) {
              return (
                <span className={styles['bold']} key={strKey}>
                  {value}
                </span>
              );
            }

            return value;
          })}
        </li>
      ))}
    </ul>
  );
};
